import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { ReactComponent as InfoIcon } from "images/icons/informations.svg";
import Tooltip from "components/Tooltip";

export default function InfoTooltip({ text, Icon, className }) {
  const IconElement = Icon ?? InfoIcon;

  return (
    <Tooltip content={text} className="mr-2 align-middle h-5">
      <IconElement className={clsx("h-5 cursor-help", className)} />
    </Tooltip>
  );
}

InfoTooltip.propTypes = {
  text: PropTypes.string.isRequired,
  Icon: PropTypes.any,
  className: PropTypes.string,
};
